export default "<iframe [src]=\"ticketPreview\" frameborder=\"0\"></iframe>"